import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import client from "../lib/api";
import { useSeo } from "../lib/useSeo";
import Layout, { Spinner } from "../components/Layout";
import { NewsCard } from "../components/NewsCard";
import { Search as SearchIcon } from "lucide-react";

export default function Search() {
  const [params, setParams] = useSearchParams();
  const q = params.get("q") || "";
  const [input, setInput] = useState(q);
  const [items, setItems] = useState(null);
  const [total, setTotal] = useState(0);
  useSeo({ title: q ? `Search: ${q}` : "Search", description: `Search results for ${q} on Rapid24News` });

  useEffect(() => {
    setInput(q);
    if (!q) { setItems([]); return; }
    setItems(null);
    client.get(`/search`, { params: { q, limit: 30 } }).then((r) => { setItems(r.data.items); setTotal(r.data.total); });
  }, [q]);

  const submit = (e) => { e.preventDefault(); if (input.trim()) setParams({ q: input.trim() }); };

  return (
    <Layout>
      <section className="max-w-7xl mx-auto px-4 py-8">
        <h1 className="font-head font-bold text-3xl md:text-4xl uc mb-4">Search <span className="text-r24-red">Rapid24News</span></h1>
        <form onSubmit={submit} className="flex gap-2 max-w-2xl mb-8" data-testid="search-page-form">
          <div className="flex-1 flex items-center border-2 border-black px-3">
            <SearchIcon size={18} className="text-gray-400" />
            <input value={input} onChange={(e) => setInput(e.target.value)} data-testid="search-page-input"
              placeholder="Person, place, district, police station, keyword, category..." className="flex-1 px-3 py-3 outline-none" />
          </div>
          <button className="bg-r24-red text-white font-bold uc px-6" data-testid="search-page-submit">Search</button>
        </form>

        {q && items !== null && <p className="text-gray-500 mb-6 text-sm">{total} result{total !== 1 ? "s" : ""} for <strong>"{q}"</strong></p>}
        {items === null ? <Spinner /> : items.length === 0 ? (
          q ? <p className="text-gray-500 py-16 text-center" data-testid="no-results">No stories found. Try different keywords.</p> : <p className="text-gray-400 py-16 text-center">Enter a keyword to search current and historical stories.</p>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-x-6 gap-y-8" data-testid="search-results">
            {items.map((a) => <NewsCard key={a.slug} a={a} />)}
          </div>
        )}
      </section>
    </Layout>
  );
}
